import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	editPrompt: {
		id: 'fabric.editor.ai.screens.preview.header.edit',
		defaultMessage: 'Edit prompt',
		description: 'Label for the edit prompt button in the preview screen',
	},
});
